const NotFound = () => {
  return (
    <div className="not-found">
      <h1>404 - Page Not Found</h1>
      <p>The page you're looking for doesn't exist or access is unauthorized.</p>
    </div>
  );
};

export default NotFound;
